import React, {
  useCallback, useMemo, useState, ReactElement,
} from 'react';
import ExpansionGroup from '../expansion-group/expansion-group.component';
import CheckAccess from '../check-access/check-access.component';
import FormatService from '../../services/format-service';
import useStylesExpansionGroupWidget from './expansion-group-widget.styles';

const ExpansionGroupWidget: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    headerName,
    permission,
    children,
  } = props;

  const [isExpanded, setIsExpanded]: [boolean, Function] = useState(false);

  const { classes } = useStylesExpansionGroupWidget();

  const expandedClassName: string | undefined = isExpanded ? classes.expansionGroupWidgetExpanded : undefined;

  const permissions: string[] = useMemo((): string[] => (
    permission ? [permission] : []
  ), [permission]);

  const onExpandPanel: Function = useCallback((): void => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  return (
    <CheckAccess permissions={permissions}>
      <ExpansionGroup
        isTableGroup
        withExpandedOffset
        isExpanded={isExpanded}
        headerComponent={headerName}
        className={FormatService.formatClassNames(classes.expansionGroupWidget, expandedClassName)}
        onChange={onExpandPanel}
      >
        {children}
      </ExpansionGroup>
    </CheckAccess>
  );
});

export default ExpansionGroupWidget;
